export default __webpack_public_path__ + "static/media/fleet.c1b0d273.png";